import defaultHeaders from "../apiConfig";
import { callService, callServiceFile } from "../apiService";

export async function getInvestors() {
  try {
    let request = {
      url: "/services/investors/getInvestors",
      method: "GET",
      headers: defaultHeaders
    };
    const { error, response } = await callService(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getFondi(payload) {
  try {
    let request = {
      url: "/services/fondo/getFondi",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    const { error, response } = await callService(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getClientDocuments(payload) {
  try {
    let request = {
      url: "/services/document/getClientDocuments",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    const { error, response } = await callService(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getPositionByFund(payload) {
  try {
    let request = {
      url: "/services/investors/getPositionByFund",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    const { error, response } = await callService(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getQuarterlyReports(payload) {
  try {
    let request = {
      url: "/services/document/getQuarterlyReports",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    const { error, response } = await callService(request);
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getCapitalAccountStatement(payload) {
  try {
    let request = {
      url: "/services/document/getCapitalAccountStatement",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getLegalDocument(payload) {
  try {
    let request = {
      url: "/services/document/getLegalDocument",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getCapitalCallAndDistributiont(payload) {
  try {
    let request = {
      url: "/services/document/getCapitalCallAndDistributiont",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getOtherDocument(payload) {
  try {
    let request = {
      url: "/services/document/getOtherDocument",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getPortfolioSynthesis(payload) {
  try {
    let request = {
      url: "/services/portfolio/getPortfolioSynthesis",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getPortfolioDetail(payload) {
  try {
    let request = {
      url: "/services/portfolio/getPortfolioDetail",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getPortfolioHistory(payload) {
  try {
    let request = {
      url: "/services/portfolio/getPortfolioHistory",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getInvestorsPosition() {
  try {
    let request = {
      url: "/services/investors/getInvestorsPosition",
      method: "GET",
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callService(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getExcelHistoryData(payload) {
  try {
    let request = {
      url: "/services/portfolio/downloadHistoryExcel",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callServiceFile(request);
    /*if (!error) {
      return { response };*/
    if (error) {
      const error = await response.json();
      return { response, error };
    } else {
      const data = await response;
      return { response: data };
    }
  } catch (error) {
    return { error };
  }
}

export async function getFile(payload) {
  try {
    let request = {
      url: "services/document/downloadFile",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callServiceFile(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function getDownloadFileService(payload) {
  console.log("sono qui");
  try {
    let request = {
      url: "/services/document/downloadFile",
      method: "POST",
      body: payload,
      headers: defaultHeaders
    };
    /*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
    const { error, response } = await callServiceFile(request);
    /*if (!error) {
      return { response };*/
    if (!error) {
      return { response };
    } else {
      return { error, response };
    }
  } catch (error) {
    return { error };
  }
}

export async function allegatiFondiService(payload) {
	try {
		let request = {
		url: '/services/document/downloadFile/allegatiFondi',
		method: 'POST',
		body: payload,
		headers: defaultHeaders,
	};
	/*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
	const { error, response } = await callServiceFile(request);
	/*if (!error) {
		return { response };*/
	if (!error) {
		return { response };
	} else {
		return { error, response };
	}
	} catch (error) {
		return { error };
	}
}
export async function casService(payload) {
	try {
		let request = {
		url: '/services/document/downloadFile/cas',
		method: 'POST',
		body: payload,
		headers: defaultHeaders,
	};
	/*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
	const { error, response } = await callServiceFile(request);
	/*if (!error) {
		return { response };*/
	if (!error) {
		return { response };
	} else {
		return { error, response };
	}
	} catch (error) {
		return { error };
	}
}
export async function ccdService(payload) {
	try {
		let request = {
		url: '/services/document/downloadFile/ccd',
		method: 'POST',
		body: payload,
		headers: defaultHeaders,
	};
	/*request.headers.Authorization = 'Bearer ' + payload.authorization;*/
	const { error, response } = await callServiceFile(request);
	/*if (!error) {
		return { response };*/
	if (!error) {
		return { response };
	} else {
		return { error, response };
	}
	} catch (error) {
		return { error };
	}
}

